// 简易历史缓存：使用 localStorage 存储最近一次成功获取的历史记录
const STORAGE_KEY = 'JDBH_HISTORY_CACHE';
const CURRENT_KEY = 'JDBH_CURRENT_CALC_CACHE';

// 为缓存键增加按用户命名空间，避免不同用户间数据泄露
const getUserKeySuffix = () => {
  try {
    const raw = localStorage.getItem('relay_user');
    if (!raw) return 'anon';
    const parsed = JSON.parse(raw);
    const uid = parsed?.id || parsed?.openid || 'anon';
    return String(uid);
  } catch (_) {
    return 'anon';
  }
};

const getScopedKey = (base) => `${base}:${getUserKeySuffix()}`;

export const getHistoryCache = () => {
  try {
    // 优先读取按用户命名空间的键
    let raw = localStorage.getItem(getScopedKey(STORAGE_KEY));
    // 回退至旧版全局键以兼容历史数据
    if (!raw) raw = localStorage.getItem(STORAGE_KEY);
    const parsed = JSON.parse(raw || '[]');
    if (Array.isArray(parsed)) {
      // 旧格式：直接存数组
      return parsed;
    }
    if (parsed && typeof parsed === 'object' && Array.isArray(parsed.list)) {
      return parsed.list;
    }
    return [];
  } catch (_) {
    return [];
  }
};

export const setHistoryCache = (arr) => {
  try {
    const data = Array.isArray(arr) ? arr : [];
    const payload = { list: data, ts: Date.now() };
    // 仅写入命名空间键（避免污染其他用户）
    localStorage.setItem(getScopedKey(STORAGE_KEY), JSON.stringify(payload));
  } catch (_) {}
};

export const getHistoryCacheInfo = () => {
  try {
    let raw = localStorage.getItem(getScopedKey(STORAGE_KEY));
    if (!raw) raw = localStorage.getItem(STORAGE_KEY);
    const parsed = JSON.parse(raw || '[]');
    if (Array.isArray(parsed)) {
      // 旧格式兼容
      return { list: parsed, ts: null };
    }
    if (parsed && typeof parsed === 'object') {
      const list = Array.isArray(parsed.list) ? parsed.list : [];
      const ts = typeof parsed.ts === 'number' ? parsed.ts : null;
      return { list, ts };
    }
    return { list: [], ts: null };
  } catch (_) {
    return { list: [], ts: null };
  }
};

// 清空历史缓存（当前用户命名空间与旧版全局键）
export const clearHistoryCache = () => {
  try { localStorage.removeItem(getScopedKey(STORAGE_KEY)); } catch (_) {}
  try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
};

// 本地当前计算缓存（未登录时用于叠加）
export const setCurrentCalculationCache = (record) => {
  try {
    const payload = { record, ts: Date.now() };
    // 仅在未登录时写入（按照设计“未登录用于叠加”）
    const userSuffix = getUserKeySuffix();
    if (userSuffix === 'anon') {
      localStorage.setItem(`${CURRENT_KEY}:anon`, JSON.stringify(payload));
    }
  } catch (_) {}
};

export const getCurrentCalculationCache = () => {
  try {
    // 仅从未登录命名空间读取（与写入策略保持一致）
    const raw = localStorage.getItem(`${CURRENT_KEY}:anon`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') {
      return parsed.record || null;
    }
    return null;
  } catch (_) {
    return null;
  }
};

export const clearCurrentCalculationCache = () => {
  try { localStorage.removeItem(`${CURRENT_KEY}:anon`); } catch (_) {}
  try { localStorage.removeItem(getScopedKey(CURRENT_KEY)); } catch (_) {}
};